module.exports = __webpack_public_path__ + "img/pantalla-8-3.6f3a83ee.png";